$(document).ready(function () {
    var updateData = {};
  
  // if the cart page isn't empty 
    if ($(".empty-page-content").hasClass("hide")) {
        if (sessionStorage.getItem("ModalOpened")) {
            // has been opened before, don't open automatically again 
          console.log("opened before");
        } else {
            // never been opened before, auto open it now and set the localStorage to true 
          console.log("never opened before");

            // open modal
            setTimeout(function(){
                if (window.matchMedia("(min-width: 768px)").matches) {
                  window.scrollTo(0,0);
                  $("html").addClass("overflow-stop");
                }
                $(".modal-container").addClass("appear");
                $(".modal-background-black").addClass("appear");
              
              // send GA event 
              ga('send','event','CartProductRec','AutoModalOpened', 'AutoModalOpened');
            }, 1000);

            // set sessionStorage after 5 seconds on page
            setTimeout(function(){
              sessionStorage.setItem("ModalOpened", true);
          }, 5000);

            
        }
    }
  
  

    $(document).on('click','.bundleProductRemove',function(){

      let bundleData = $(this).data("bundle-product-skus");

      var bundleDataArray = bundleData.split("-");

      var bundleQuantity = parseInt($(this).data("quantity"));

      // loop through the bundle array, for each SKU, find the current quantity of items in the cart 
      for (var i = 0; i < bundleDataArray.length; i++) {
        var itemVariantID = bundleDataArray[i];

        var itemQuantity;

        if (itemVariantID in updateData == true){
          itemQuantity = updateData[itemVariantID];
        } else {
          itemQuantity = parseInt($("#" + itemVariantID).data("quantity"));
        };

        var updatedItemQuantity = itemQuantity - bundleQuantity;

        updateData[itemVariantID] = updatedItemQuantity;
      }

      var bundleVariantID = $(this).data("line-item-key");

      updateData[bundleVariantID] = 0


      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        dataType: 'json',
        data: {
          updates: updateData
        },
        success: function(){
          location.href="/cart";
        }
      });
    });

    $(document).on('click','.removeItemLink',function(){

      var itemKey = $(this).data("line-item-key");

      updateData[itemKey] = 0


      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        dataType: 'json',
        data: {
          updates: updateData
        },
        success: function(){
          location.href="/cart";
        }
      });
    });
  }); 

var loadProductRecommendationsIntoSection = function() {
       // Look for an element with class 'product-recommendations-bottom'
       var productRecommendationsSection = document.querySelector("#product-recommendations-bottom");
       if (productRecommendationsSection === null) { return; }
       // Read product id from data attribute
       var productId = productRecommendationsSection.dataset.productId;
       // Read limit from data attribute
       var limit = productRecommendationsSection.dataset.limit;
       // Build request URL
       var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
       // Create request and submit it using Ajax
       var request = new XMLHttpRequest();
       request.open("GET", requestUrl);
       request.onload = function() {
         if (request.status >= 200 && request.status < 300) {
           var container = document.createElement("div");
           container.innerHTML = request.response;
           document.getElementById("product-recommendations-bottom").innerHTML = container.innerHTML;
         }
       };
       request.send();
     };
    
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();
    
    let progressBar = $(".progressBarWidthPercent").attr("id")
    var progressBarWidth = progressBar + "%";
    $("#progress-indicator").css("width", progressBarWidth);
    
    setTimeout(function(){ 
      $("#openModal").css("opacity", 1)
    }, 500)
    
    var modal = document.getElementById("myModal");

    $("#openModal").click(function(){
      // send GA event 
      ga('send','event','CartProductRec','ModalClicked', 'ModalOpened');
      
      
      if (window.matchMedia("(min-width: 768px)").matches) {
        window.scrollTo(0,0);
        $("html").addClass("overflow-stop");
      }
      $(".modal-container").addClass("appear");
      $(".modal-background-black").addClass("appear");
    })

    $("#closeButton").click(function(){
      $(".modal-container").removeClass("appear");
      $(".modal-background-black").removeClass("appear");
      $("html").removeClass("overflow-stop");
    })

    window.onclick = function(event) {
      if (event.target == modal) {
        $(".modal-container").removeClass("appear");
        $(".modal-background-black").removeClass("appear");
        $("html").removeClass("overflow-stop");
      }
    };
    
    $(document).on('click','.modal-add-to-cart',function(){
      // send GA event 
      ga('send','event','CartProductRec','AddToCart', 'ProductAddedToCart');
      
      var variantID = $(this).data("variant-id");
      
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {items: 
               [
                 {
                   id: variantID,
                   quantity: 1
                 }
               ]},
        success: function(){
          location.href="/cart";
        }
      });
    })
    
    $(document).on('click', '.product-image a', function(){
      // send GA event 
      ga('send','event','CartProductRec','ProductClicked', 'ClickedOnProduct');
    })
    
    $(document).on('click', '.product-description a', function(){
      // send GA event 
      ga('send','event','CartProductRec','ProductClicked', 'ClickedOnProduct');
    })
